import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, message } from 'antd';
import TcButton from 'components/UI/button/TcButton';
import TcDevider from 'components/UI/Devider/TcDevider';
import TcInput from 'components/UI/form/input/TcInput';
import TcForm from 'components/UI/form/TcForm';
import TcFormItem from 'components/UI/form/TcFormItem';
import LocationPicker from 'components/UI/Map/LocationPicker';
import TcModal from 'components/UI/Modal/TcModal';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import { numberRegex } from 'global/Constants/globalConstants';
import { omOrderServices, packageCreate } from 'global/Models/omOrderModel';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
interface props {
  visible: boolean;
  selectReceiverLocation:
    | {
        routeIndex: number;
        hasLatLong: boolean;
        hasPostalCode: boolean;
      }
    | undefined;
  close: () => void;
  packages: packageCreate[];
  setOrderServices: React.Dispatch<React.SetStateAction<omOrderServices>>;
}
const SelectReceiverLocationModal: FC<props> = ({ visible, selectReceiverLocation, close, packages, setOrderServices }) => {
  //states
  const { allCitiesWithoutSearch } = useSelector((state: RootState) => state.city);
  const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number }>();
  const { map } = useSelector((state: RootState) => state.map);
  const [showMap, setShowMap] = useState<boolean>(false);
  //hooks
  const [form] = Form.useForm();
  //effect
  useEffect(() => {
    visible &&
      setTimeout(() => {
        setShowMap(true);
      }, 1000);
    !visible && setShowMap(false);
  }, [visible]);

  useEffect(() => {
    if (selectedLocation) {
      form.setFieldValue('longitude', selectedLocation.lng);
      form.setFieldValue('latitude', selectedLocation.lat);
    }
  }, [selectedLocation]);

  //functions
  const handleLocationPick = (location: { lat: number; lng: number }) => {
    setSelectedLocation(location);
  };
  const handleChange = (value: any) => {
    if (value.cityId && allCitiesWithoutSearch) {
      const city = allCitiesWithoutSearch.find((city) => city.id === value.cityId);
      if (map && city?.latitude && city?.longitude) {
        map.flyTo([city.latitude, city.longitude], 11);
      }
    }
  };
  const handleSubmit = (values: any) => {
    if ((!selectReceiverLocation?.hasLatLong && !selectedLocation?.lat) || !selectedLocation?.lng) return message.error('لطفا موقعیت مکانی را انتخاب کنید');
    if (!values.postalCode && !selectReceiverLocation?.hasPostalCode) return message.error('لطفا کدپستی را وارد کنید');
    if (selectReceiverLocation?.routeIndex == null) return;
    const receiverAddress = packages[selectReceiverLocation?.routeIndex]?.receiverAddress?.address;
    if (receiverAddress) {
      receiverAddress.latitude = selectedLocation?.lat ?? receiverAddress.latitude;
      receiverAddress.longitude = selectedLocation?.lng ?? receiverAddress.longitude;
    }

    if (values.postalCode && receiverAddress) {
      receiverAddress.postalCode = values.postalCode;
    }
    // Update selectReceiverLocation values
    selectReceiverLocation.hasLatLong = true;
    selectReceiverLocation.hasPostalCode = true;

    setOrderServices((prevOrderServices) => {
      const updatedOrderServices = prevOrderServices.map((route, _routeIndex) => {
        route.serviceList = route.serviceList.map((service) => {
          if (service.serviceId === 11) {
            service.selected = true;
          } else {
            service.selected = false;
          }
          return service;
        });

        return route;
      });

      return [...updatedOrderServices];
    });

    form.resetFields();
    setSelectedLocation(undefined);
    close();
    return;
  };

  return (
    <TcModal title='ثبت لوکیشن و کدپستی گیرنده' visible={visible} onCancel={close} footer={false}>
      <TcForm form={form} onFinish={handleSubmit} onValuesChange={handleChange}>
        <div className='flex flex-col gap-4 '>
          {!selectReceiverLocation?.hasLatLong && !selectReceiverLocation?.hasPostalCode && (
            <p>
              <span className='text-t-error-color inherit-color'>
                <InfoCircleOutlined className='ml-1' />
              </span>
              <span className='mt-3 text-base'>
                برای انتخاب سرویس NextDay ثبت لوکیشن و کد پستی <b>گیرنده</b> اجباری است.
              </span>
            </p>
          )}

          {(selectReceiverLocation?.hasLatLong && !selectReceiverLocation?.hasPostalCode) || (!selectReceiverLocation?.hasLatLong && selectReceiverLocation?.hasPostalCode) ? (
            <span className='mt-3 text-base'>{`برای انتخاب سرویس NextDay انتخاب ${!selectReceiverLocation?.hasLatLong ? 'موقعیت مکانی' : 'کدپستی'} گیرنده اجباری است.`}</span>
          ) : null}

          {!selectReceiverLocation?.hasPostalCode && (
            <TcFormItem
              label='کدپستی'
              name='postalCode'
              rules={[
                {
                  required: true,
                  max: 10,
                  min: 10,
                  message: 'کدپستی یک عدد 10 رقمی می‌باشد',
                },
                {
                  whitespace: true,
                  message: 'کدپستی نمی‌تواد شامل فاصله باشد',
                },
                {
                  pattern: numberRegex,
                  message: 'کدپستی شامل اعداد می‌باشد',
                },
              ]}>
              <TcInput placeholder='کدپستی' />
            </TcFormItem>
          )}
          {!selectReceiverLocation?.hasLatLong && showMap && (
            <div className='w-full'>
              <TcDevider className='mt-0'> انتخاب نشانی بر روی نقشه</TcDevider>
              <LocationPicker selectedLocation={selectedLocation} setSelectedLocation={handleLocationPick} />
            </div>
          )}
        </div>

        <div className='flex justify-end mt-6'>
          <TcButton type='primary' htmlType='submit'>
            ثبت
          </TcButton>
        </div>
      </TcForm>
      {!showMap && <TcCoverLoading />}
    </TcModal>
  );
};
export default SelectReceiverLocationModal;
